import * as React from 'react';
import { useResourceDefinitions } from 'ra-core';
import { ResourceMenuItem } from './ResourceMenuItem';
export var ResourceMenuItems = function () {
    var resources = useResourceDefinitions();
    return (React.createElement(React.Fragment, null, Object.keys(resources)
        .filter(function (name) { return resources[name].hasList; })
        .map(function (name) { return (React.createElement(ResourceMenuItem, { key: name, name: name })); })));
};
//# sourceMappingURL=ResourceMenuItems.js.map